import { createSlice } from '@reduxjs/toolkit'
import { INewApplication, NewApplicationSchema } from '../types/NewApplication'
import { UserRightType } from '../../../../entities/User'
import { addNewApplication } from '../services/addNewApplication'

const newApplication: INewApplication = {
	name: '',
	expirationDate: undefined,
	rights: {
		clients: UserRightType.NO_PERMISSION,
		licenses: UserRightType.NO_PERMISSION,
		products: UserRightType.NO_PERMISSION,
		instances: UserRightType.NO_PERMISSION,
		users: UserRightType.NO_PERMISSION
	}
}

const initialState: NewApplicationSchema = {
	isLoading: false,
	error: '',
	newApplication
}

const newApplicationSLice = createSlice({
	name: 'newApplication',
	initialState,
	reducers: {
		resetNewApp: (state) => {
			state.newApplication = newApplication
		},
		setName: (state, action) => {
			state.newApplication.name = action.payload
		},
		setExpirationDate: (state, action) => {
			state.newApplication.expirationDate = action.payload
		},
		setClientsRights: (state, action) => {
			state.newApplication.rights.clients = action.payload
		},
		setProductsRights: (state, action) => {
			state.newApplication.rights.products = action.payload
		},
		setLicensesRights: (state, action) => {
			state.newApplication.rights.licenses = action.payload
		},
		setInstancesRights: (state, action) => {
			state.newApplication.rights.instances = action.payload
		},
		setUsersRights: (state, action) => {
			state.newApplication.rights.users = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(addNewApplication.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(addNewApplication.fulfilled, (state) => {
				state.isLoading = false
			})
			.addCase(addNewApplication.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: newApplicationActions } = newApplicationSLice
export const { reducer: newApplicationReducer } = newApplicationSLice
